import { SVGProps } from "react";

export default function ArrowFailureIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M8.36758 13.2348C8.4441 13.1546 8.55016 13.1027 8.67387 13.0998L13.2429 12.9929L13.136 8.42388C13.1304 8.1847 13.3237 7.98214 13.5629 7.97655C13.8021 7.97095 14.0046 8.16426 14.0102 8.40343L14.1273 13.4096C14.1329 13.6487 13.9396 13.8513 13.7004 13.8569L8.69432 13.974C8.45514 13.9796 8.25258 13.7863 8.24698 13.5471C8.24006 13.4276 8.29107 13.315 8.36758 13.2348Z"
        fill="#FF4646"
      />
      <path
        d="M6.19955 6.27057C6.36467 6.09755 6.64508 6.09099 6.8181 6.2561L13.9206 13.0339C14.0936 13.199 14.1001 13.4794 13.935 13.6524C13.7699 13.8255 13.4895 13.832 13.3165 13.6669L6.21402 6.88912C6.041 6.724 6.03444 6.4436 6.19955 6.27057Z"
        fill="#FF4646"
      />
    </svg>
  );
}
